export default {
  // Survey data getters
  getSurveys(state) {
    return state.survey;
  },

  getCurrentQuestionNumber(state) {
    return state.currentQuestionNumber;
  },

  getSurveyResult(state) {
    return state.surveyResult;
  },

  // Survey UI state getters
  getShowSurveyVerification(state) {
    return state.showSurveyVerification;
  },

  getShowSurveyResults(state) {
    return state.showSurveyResults;
  },

  getShowSurvey(state) {
    return state.showSurvey;
  },

  // Loading state getters
  isSurveysLoading(state) {
    return state.isLoading.getSurveys;
  },

  isSurveyAnswersLoading(state) {
    return state.isLoading.surveyAnswers;
  },

  isSurveyResultsLoading(state) {
    return state.isLoading.surveyResults;
  },

  // Error state getters
  getSurveysError(state) {
    return state.errors.getSurveys;
  },

  getSurveyAnswersError(state) {
    return state.errors.surveyAnswers;
  },

  getSurveyResultsError(state) {
    return state.errors.surveyResults;
  },

  // Backward compatibility getters
  getSurveyPending(state) {
    return state.isGetSurveyPending;
  },

  // Combined getters for easier usage
  getSurveysWithLoading(state) {
    return {
      data: state.survey,
      isLoading: state.isLoading.getSurveys,
      error: state.errors.getSurveys,
    };
  },

  getSurveyResultsWithLoading(state) {
    return {
      data: state.surveyResult,
      isLoading: state.isLoading.surveyResults,
      error: state.errors.surveyResults,
    };
  },
};
